import React, { useEffect, useContext, useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./../../../assets/css/mentor/mentordashboard/MentorshipRequests.css";
import MyMasterLayout from "./../../../layouts/Mentor/MyMasterlayout";
import AppContext from "./../../../context/Appcontext";
import axios from "axios";

const MentorshipRequests = () => {
  const { baseUrl } = useContext(AppContext);

  //REQUESTS LIST
  const [requests, setRequests] = useState([]);

  // UI STATES
  const [isLoading, setIsLoading] = useState(false);
  const [acceptLoading, setAcceptLoading] = useState(null);
  const [rejectLoading, setRejectLoading] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  //READ — Requests Fetch Karna
  const fetchRequests = () => {
    const mentorData = JSON.parse(localStorage.getItem("mentorData"));
    if (!mentorData) return;

    setIsLoading(true);
    axios
      .get(`${baseUrl}/mentor/requests/${mentorData.id}`)
      .then((response) => {
        setRequests(response.data.requests || []);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        setIsLoading(false);
      });
  };

  // Page load hote hi fetch ho jaye
  useEffect(() => {
    fetchRequests();
  }, []);

  // ========== ERROR HANDLER ==========
  const handleApiError = (error) => {
    console.error("API error:", error);
    if (error.response && error.response.data) {
      if (error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage("Something went wrong. Please try again.");
      }
    } else {
      setErrorMessage("Network error. Please check your connection.");
    }
  };

  // ========== UPDATE — Accept Karna ==========
  const handleAccept = (id) => {
    setErrorMessage("");
    setSuccessMessage("");
    setAcceptLoading(id);

    axios
      .post(`${baseUrl}/mentor/requests/accept/${id}`)
      .then((response) => {
        setAcceptLoading(null);
        setSuccessMessage("Request accepted successfully!");
        fetchRequests(); // list refresh karo
        setTimeout(() => setSuccessMessage(""), 2000);
      })
      .catch((error) => {
        setAcceptLoading(null);
        handleApiError(error);
      });
  };

  // ========== UPDATE — Reject Karna ==========
  const handleReject = (id) => {
    setErrorMessage("");
    setSuccessMessage("");
    setRejectLoading(id);

    axios
      .post(`${baseUrl}/mentor/requests/reject/${id}`)
      .then((response) => {
        setRejectLoading(null);
        setSuccessMessage("Request rejected successfully!");
        fetchRequests();
        setTimeout(() => setSuccessMessage(""), 2000);
      })
      .catch((error) => {
        setRejectLoading(null);
        handleApiError(error);
      });
  };

  return (
    <MyMasterLayout>
      <div className="mr-wrapper">
        {successMessage && (
          <div className="alert alert-success py-2 mb-3">
            <i className="bi bi-check-circle me-2"></i>
            {successMessage}
          </div>
        )}
        {errorMessage && (
          <div className="alert alert-danger py-2 mb-3">
            <i className="bi bi-exclamation-triangle me-2"></i>
            {errorMessage}
          </div>
        )}
        <div className="mr-card">
          <div className="mr-table-container">
            {/* Loading Spinner */}
            {isLoading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
                <p className="mt-2 text-muted">Loading requests...</p>
              </div>
            ) : (
              <table className="mr-table">
                <thead>
                  <tr>
                    <th>STUDENT</th>
                    <th>AREA OF HELP</th>
                    <th>MESSAGE</th>
                    <th style={{ textAlign: "center" }}>STATUS</th>
                    <th style={{ textAlign: "center" }}>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((request) => (
                    <tr key={request.id}>
                      <td>
                        <div className="mr-student-info">
                          <img
                            src={
                              request.student_image ||
                              `https://randomuser.me/api/portraits/men/${request.id}.jpg`
                            }
                            alt={request.student_name}
                            className="mr-avatar"
                          />
                          <span className="mr-name">
                            {request.student_name}
                          </span>
                        </div>
                      </td>
                      <td>
                        <span className="mr-badge mr-badge-blue">
                          {request.area_of_help}
                        </span>
                      </td>
                      <td>
                        <div className="mr-message">{request.message}</div>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <span
                          className={`mr-status mr-status-${request.status}`}
                        >
                          {request.status.toUpperCase()}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {request.status === "pending" && (
                          <div className="mr-actions">
                            {/* Accept Button */}
                            <button
                              className="mr-btn mr-btn-accept"
                              onClick={() => handleAccept(request.id)}
                              disabled={acceptLoading === request.id}
                            >
                              {acceptLoading === request.id ? (
                                <span className="spinner-border spinner-border-sm"></span>
                              ) : (
                                <>
                                  <i className="bi bi-check-lg"></i> Accept
                                </>
                              )}
                            </button>

                            {/* Reject Button */}
                            <button
                              className="mr-btn mr-btn-reject"
                              onClick={() => handleReject(request.id)}
                              disabled={rejectLoading === request.id}
                            >
                              {rejectLoading === request.id ? (
                                <span className="spinner-border spinner-border-sm"></span>
                              ) : (
                                <>
                                  <i className="bi bi-x-lg"></i> Reject
                                </>
                              )}
                            </button>
                          </div>
                        )}
                        {request.status === "accepted" && (
                          <span className="mr-status-text mr-text-accepted">
                            <i className="bi bi-check-circle-fill"></i> Accepted
                          </span>
                        )}
                        {request.status === "rejected" && (
                          <span className="mr-status-text mr-text-rejected">
                            <i className="bi bi-x-circle-fill"></i> Rejected
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* Empty State */}
            {!isLoading && requests.length === 0 && (
              <div className="text-center py-5 text-muted">
                <i className="bi bi-inbox fs-1"></i>
                <p className="mt-2">No requests found</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </MyMasterLayout>
  );
};

export default MentorshipRequests;
